.EcoSuiteNavbarAccountMenu__header {
  color: var(--pdt-color-text);
  font-size: var(--pdt-font-size-sm);
  font-weight: var(--pdt-font-weight-medium);
  line-height: var(--pdt-line-height-sm);
  padding: var(--pdt-space-75) var(--pdt-space-50);
  gap: var(--pdt-space-100);
  display: flex;
  align-items: center;
}
